
import React from "react";
import {
    withGoogleMap,
    withScriptjs,
    GoogleMap,
    Marker,
} from "react-google-maps";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";

const Map = () => {

    const options = { closeBoxURL: "", enableEventPropagation: true };
    return (
        <div>
            <GoogleMap
                defaultZoom={8}
                defaultCenter={{ lat: 21.010832867122268, lng: 105.79748620826615 }}
            >
                
                        <Marker
                            icon={{
                                url: "/images/ic_hotel.png",
                                scaledSize: new window.google.maps.Size(40, 40),
                            }}
                    position={{ lat: 21.010832867122268, lng: 105.79748620826615 }}
                        >
                            <InfoBox options={options}>
                                <>
                                    <div
                                        style={{
                                            backgroundColor: "#fff",
                                            color: "#000",
                                            borderRadius: "1em",
                                            padding: "3px 10px",
                                        }}
                                    >
                                        Apec Mandala
                                    </div>
                                </>
                            </InfoBox>
                        </Marker>
                  
            </GoogleMap>
        </div>
    );
};

export default withScriptjs(withGoogleMap(Map));
